import { useParams } from 'react-router-dom';
import useIsAdmin from '../../pages/AuthenticatedPages/WorkspaceAdmin/useIsAdmin';

/**
 * Returns functions to build paths based on admin/manager context.
 * Admin: /markets/{marketId}/...
 * Manager: /manager/...
 */
export function useViewLocationsPath() {
  const isAdmin = useIsAdmin();
  const { marketId } = useParams<{ marketId: string }>();

  const getViewLocationsPath = (groupId?: string, workspaceId?: string) => {
    const effectiveWorkspaceId = workspaceId ?? marketId;
    if (effectiveWorkspaceId) {
      return groupId
        ? `/markets/${effectiveWorkspaceId}/view-locations/${groupId}`
        : `/markets/${effectiveWorkspaceId}/view-locations`;
    }

    if (isAdmin && marketId) {
      return groupId
        ? `/markets/${marketId}/view-locations/${groupId}`
        : `/markets/${marketId}/view-locations`;
    }

    return groupId
      ? `/manager/view-locations/${groupId}`
      : `/manager/view-locations`;
  };

  const getBusinessUnitPath = (businessUnitId: string, subPath?: string) => {
    const base =
      isAdmin && marketId
        ? `/markets/${marketId}/businessUnit/${businessUnitId}`
        : `/manager/businessUnit/${businessUnitId}`;
    return subPath ? `${base}/${subPath}` : base;
  };

  const getStoreDevicePath = (
    storeId: string,
    deviceId: string,
    subPath?: string
  ) => {
    const base =
      isAdmin && marketId
        ? `/markets/${marketId}/store/${storeId}/device/${deviceId}`
        : `/manager/store/${storeId}/device/${deviceId}`;
    return subPath ? `${base}/${subPath}` : base;
  };

  return {
    getViewLocationsPath,
    getBusinessUnitPath,
    getStoreDevicePath,
    isAdmin,
    marketId,
  };
}

export default useViewLocationsPath;
